import React, { Fragment } from "react"
import ListItemIcon from "@mui/material/ListItemIcon"
import ListItemText from "@mui/material/ListItemText"
import ListItem from "@mui/material/ListItem"
import { Link, ListItemButton } from "@mui/material"
import { COLORS } from "../utils"

const sx = {
    link: {
        color: COLORS.BLACK_600,
        display: "flex",
        width: "100%",
        textDecoration: "none",
        "&:hover": {
            color: COLORS.BLACK_600
        }
    },
    listItem: {
        color: COLORS.BLACK_600
    },
    listItemButton: {
        "& .MuiListItemIcon-root": {
            color: COLORS.BLACK_600
        },
        "& .MuiListItemText-primary": {
            color: COLORS.BLACK_600
        }
    }
}

const MenuIconAndText = (props) => {
    const {
        label,
        icon: MenuIcon,
        isVisible = true,
        button = true,
        upper = false,
        url,
        onClick,
        selected
    } = props

    const _onClick = () => {
        onClick && onClick()
    }

    if (!isVisible) return null

    const menuContent = (
        <Fragment>
            <ListItemIcon sx={sx.listItem}>
                <MenuIcon />
            </ListItemIcon>
            <ListItemText primary={upper ? label.toUpperCase() : label}  sx={sx.listItem} />
        </Fragment>
    )

    return (
        <>
            {
                url
                    ? (
                        <ListItem button={button}>
                            <Link sx={sx.link} href={url} underline="none">
                                {menuContent}
                            </Link>
                        </ListItem>
                    ) : (
                        <ListItemButton onClick={_onClick} selected={selected} sx={sx.listItemButton}>
                            {menuContent}
                        </ListItemButton>
                    )
            }
        </>
    )
}

export default MenuIconAndText